export default __webpack_public_path__ + "static/media/vecteezy.3e864673.png";